// extracted by css-extract-rspack-plugin
export default {"loading":"HealthcareStart__loading--e54ik"};